(function () {
    'use strict';

    angular.module('NaviaqWebApp').directive('finalReportFooterDirective', finalReportFooterDirective);

    finalReportFooterDirective.$inject = [];
    function finalReportFooterDirective() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/report/finalReportComponents/final-report-footer.html',
            scope: {
                data: '=data'
            },
            link: function (scope, element, attrs) {
            },
        };
    }
})();
